// Karussell-Navigation fuer Cross-Sell-Section
// Mobile: Pfeil-Klick + aria-disabled. Touch-Swipe via CSS scroll-snap.
// Desktop: kein Scrolling (statisches Grid), JS hat dort keine Wirkung.

(function () {
  'use strict';

  const karussells = document.querySelectorAll('[data-cs-karussell]');

  karussells.forEach((karussell) => {
    const list = karussell.querySelector('[data-cs-karussell-list]');
    const navPrev = karussell.querySelector('[data-cs-nav="prev"]');
    const navNext = karussell.querySelector('[data-cs-nav="next"]');

    if (!list || !navPrev || !navNext) return;

    // Karten-Breite + Gap dynamisch ermitteln
    const getScrollAmount = () => {
      const item = list.querySelector('.pdp-cross-sell__item');
      if (!item) return 0;
      const gap = parseFloat(window.getComputedStyle(list).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    };

    // Scroll-Verhalten: instant bei prefers-reduced-motion
    const getScrollBehavior = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

    // aria-disabled + disabled der Pfeil-Buttons aktualisieren
    const updateNavState = () => {
      const scrollLeft = list.scrollLeft;
      const maxScroll = list.scrollWidth - list.clientWidth;

      const isAtStart = scrollLeft <= 1;
      navPrev.disabled = isAtStart;
      navPrev.setAttribute('aria-disabled', String(isAtStart));

      const isAtEnd = scrollLeft >= maxScroll - 1;
      navNext.disabled = isAtEnd;
      navNext.setAttribute('aria-disabled', String(isAtEnd));
    };

    navPrev.addEventListener('click', () => {
      list.scrollBy({ left: -getScrollAmount(), behavior: getScrollBehavior() });
    });

    navNext.addEventListener('click', () => {
      list.scrollBy({ left: getScrollAmount(), behavior: getScrollBehavior() });
    });

    // Nach Touch-Swipe ebenfalls Pfeil-Status aktualisieren
    list.addEventListener('scroll', updateNavState);

    // Initial-Status setzen
    updateNavState();

    // Bei Resize neu berechnen (Viewport-Aenderung aendert Karten-Breite)
    window.addEventListener('resize', updateNavState);
  });
})();
